import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, FormGroup, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useState, useEffect, useRef } from 'react';
import { Auth, SignOut, ListAppSegments, UpdateAppSegment, UpdateAppConnectorGroup } from '../../../functions/ZPA';
import Spinner from 'react-bootstrap/Spinner';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Multiselect from 'multiselect-react-dropdown';
import Badge from 'react-bootstrap/Badge';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { objectToOperationString } from '../../../functions/misc';
import InputGroup from 'react-bootstrap/InputGroup';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode'

function UpdateAppSegmentTab({ groups, verified, showVerifyWindow, setShowVerifyWindow, setVerifyOperation, setVerified, selectedTab }) {
    const [isLoading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Authenticating...")
    const [tenant, setTenant] = useState("Rheintec");
    const [outputConsole, setOutputConsole] = useState("");
    const [appSegments, setAppSegments] = useState({ "Rheintec": [], "Helvetia": [] });
    const [selected, setSelected] = useState([]);
    const [accessToken, setAccessToken] = useState("");
    const textareaRef = useRef();
    const [updated, setUpdated] = useState([]);
    const [failed, setFailed] = useState([]);

    const [status, setStatus] = useState("No Change")
    const [doubleEncrypt, setDoubleEncrypt] = useState("No Change")
    const [icmpAccessType, setIcmpAccessType] = useState("No Change")
    const [bypassDuringReauthentication, setBypassDuringReauthentication] = useState("No Change")
    const [isCnameEnabled, setIsCnameEnabled] = useState("No Change")
    const [bypassType, setBypassType] = useState("No Change")
    const [healthReporting, setHealthReporting] = useState("No Change")
    const [selectConnectorCloseToApp, setSelectConnectorCloseToApp] = useState("No Change")
    const [descriptionTag, setDescriptionTag] = useState("")
    const [description, setDescription] = useState("")
    const [tcpPortRanges, setTcpPortRanges] = useState([])
    const [udpPortRanges, setUdpPortRanges] = useState([])
    const [tcpPortsAsText, setTcpPortsAsText] = useState("")
    const [udpPortsAsText, setUdpPortsAsText] = useState("")
    const [replacePortRanges, setReplacePortRanges] = useState("No Change")
    const [isValidPortRanges, setIsValidPortRanges] = useState(true)
    const [tcpTextView, setTcpTextView] = useState(false)
    const [udpTextView, setUdpTextView] = useState(false)
    useEffect(() => {
        console.log(tcpTextView)
    }, [tcpTextView])

    const multiselectRef = useRef();


    function appendConsole(text) {
        setOutputConsole(prevOutput => prevOutput + text);
    }
    function appendConsoleSeperatorMain(skipNewLine) {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount));
        setOutputConsole(prevOutput => prevOutput + (skipNewLine ? "" : "\n") + dashes);
    }
    function appendConsoleSeperatorSecondary() {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount / 2));
        setOutputConsole(prevOutput => prevOutput + "\n" + "\t" + dashes);
    }

    async function getAppSegments() {
        let newAppSegments = { ...appSegments };
        setAppSegments({ "Rheintec": [], "Helvetia": [], "Credaris": [] })
        Object.keys(appSegments).forEach(async (key) => {
            const access_token = await authenticate(key);
            if (access_token) {
                const app_segments_response = await ListAppSegments(access_token, key)
                const app_segments_json = await app_segments_response.json()

                if (app_segments_response.status === 200) {
                    const app_segments = app_segments_json.app_segments;
                    newAppSegments[key] = app_segments;

                    setAppSegments({ ...newAppSegments });
                }
                else {
                    appendConsole(`\nError: ${app_segments_response.message}`);
                    appendConsoleSeperatorMain();
                }
            }

        });

    }

    async function authenticate(tenant) {
        try {
            const response = await Auth(tenant);
            const auth_json = await response.json();
            if (response.status === 200) {
                const access_token = auth_json.access_token;
                return access_token;
            }
            else {
                appendConsole(`\nAuth Error: ${tenant} - ${auth_json.message}`);
                appendConsoleSeperatorMain();
            }
        }
        catch (error) {
            appendConsole(`\nAuth Error: ${tenant} - ${error.message}`);
            appendConsoleSeperatorMain();
        }
    }

    function modifyAppSegments() {
        const newSelected = selected.map((element) => {
            const updatedElement = { "id": element.id, "name": element.name };

            if (status !== null && status !== undefined && status !== "No Change") {
                updatedElement.enabled = status;
            }

            if (bypassType !== null && bypassType !== undefined && bypassType !== "No Change") {
                updatedElement.bypassType = bypassType;
            }

            if (healthReporting !== null && healthReporting !== undefined && healthReporting !== "No Change") {
                updatedElement.healthReporting = healthReporting;
            }

            if (icmpAccessType !== null && icmpAccessType !== undefined && icmpAccessType !== "No Change") {
                updatedElement.icmpAccessType = icmpAccessType;
            }

            if (isCnameEnabled !== null && isCnameEnabled !== undefined && isCnameEnabled !== "No Change") {
                updatedElement.isCnameEnabled = isCnameEnabled;
            }

            if (selectConnectorCloseToApp !== null && selectConnectorCloseToApp !== undefined && selectConnectorCloseToApp !== "No Change") {
                updatedElement.selectConnectorCloseToApp = selectConnectorCloseToApp;
            }

            if (bypassDuringReauthentication !== null && bypassDuringReauthentication !== undefined && bypassDuringReauthentication !== "No Change") {
                updatedElement.bypassDuringReauthentication = bypassDuringReauthentication;
            }

            if (replacePortRanges !== "No Change") {
                if (tcpPortRanges.length > 0) {
                    updatedElement.tcpPortRange = createPortRangeArray(tcpPortRanges)
                    updatedElement.tcpPortRanges = tcpPortRanges.flat()
                }
                if (udpPortRanges.length > 0) {
                    updatedElement.udpPortRange = createPortRangeArray(udpPortRanges)
                    updatedElement.udpPortRanges = udpPortRanges.flat()
                }
            }

            return updatedElement;
        });
        console.log(newSelected)
        return newSelected
    }

    function createPortRangeArray(ranges) {
        var rangeArray = [];
        for (const range of ranges) {
            var rangeObject = {};
            rangeObject["from"] = range[0];
            rangeObject["to"] = range[1];
            rangeArray.push(rangeObject)
        }
        return rangeArray
    }
    async function handleSubmit(event) {
        if (!isValidPortRanges) {
            return;
        }
        const selectedNames = selected.map(element => element.name)
        const obj = {
            "Tenant": tenant,
            "Operation": `Update App Segment(s)`,
            "Affected Resources": {
                [`App Segments`]: selectedNames
            }
        }
        if (!verified) {
            try {
                const operationString = objectToOperationString(obj);
                setVerifyOperation(operationString);
                setShowVerifyWindow(true);

            } catch (error) {
                console.log(error)
            } finally {
                event.preventDefault();
                return
            }

        }

        //Prerequisites
        setUpdated([]);
        setFailed([])
        setOutputConsole(``);
        setLoading(true);
        event.preventDefault();

        //Authenticate
        setLoadingMessage("Initiating Session...");
        const access_token = await authenticate(tenant);
        setAccessToken(access_token);
        setOutputConsole(`Authenticated`);
        appendConsoleSeperatorMain();
        try {
            setLoadingMessage("Updating App Segments...");
            appendConsole(`\n${selected.filter((element) => element.name != "Select All").length} app segment(s)`);
            appendConsoleSeperatorMain();

            const modifiedSelected = modifyAppSegments()

            for (const element of modifiedSelected) {
                if (element.name === "Select All") {
                    continue;
                }
                try {
                    console.log("TENANT: " + tenant)
                    let response = await UpdateAppSegment(element, description, replacePortRanges, access_token, tenant)
                    const response_data = await response.json();
                    if (response.status === 200) {
                        setUpdated((prev) => [...prev, element.name])
                    } else if (response.status === 429) {
                        console.log("429")
                    }
                    else {
                        console.log(response.status)
                        setFailed((prev) => [...prev, { name: element.name, message: response_data.message }]);
                    }

                }
                catch (error) {
                    console.log(error)
                    setFailed((prev) => [...prev, { name: element.name, message: error.message }]);
                }
            }


        }
        catch (error) {
            appendConsole(`\nError: ${error.message}`)
            console.log(error)
            terminateSession(access_token)
        }



    }

    function evaluateSelect(selectedList, selectedItem) {
        let newSelected;
        if (selectedItem.name === "Select All") {
            newSelected = [{ "name": "Select All" }, ...appSegments[tenant]]
        }
        else {
            newSelected = selectedList;
        }
        setSelected(newSelected)

    }

    function evaluateRemove(selectedList, selectedItem) {
        if (selectedItem.name === "Select All") {
            setSelected([])
            return
        }
        setSelected(selectedList)

    }

    // Function to scroll the textarea to the bottom
    const scrollToBottom = () => {
        textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    };

    const scrollToTop = () => {
        textareaRef.current.scrollTop = 0;
    };

    function outputResponseUserStatus() {
        setOutputConsole("");
        appendConsoleSeperatorMain(true);
        appendConsole(`\nUpdated ${updated.length}/${selected.filter((element) => element.name != "Select All").length} App Segment(s)`);
        if (updated.length === 0) {
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tNo App Segment updated :(`)
        }
        for (const element of updated) {
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tName: ${element}`);
        }
        appendConsoleSeperatorSecondary();
        appendConsoleSeperatorMain();

        appendConsole(`\nFailed ${failed.length}/${selected.filter((element) => element.name != "Select All").length} App Segment`);
        if (failed.length === 0) {
            appendConsoleSeperatorSecondary();
            appendConsole("\n\tNo app segments failed to update :)")
        }
        for (const fail of failed) {
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tName: ${fail.name} \n\tReason: ${fail.message}`);
        }
        appendConsoleSeperatorSecondary();
        appendConsoleSeperatorMain();
    }

    function handleTcpChange(newValue, index, position) {

        if (newValue < 0 || newValue > 65535) {
            return
        }
        var newTcpPortRanges = [...tcpPortRanges];
        newTcpPortRanges[index][position] = newValue;
        setTcpPortRanges(newTcpPortRanges)
    }

    function handleUdpChange(newValue, index, position) {
        if (newValue < 0 || newValue > 65535) {
            return
        }
        var newUdpPortRanges = [...udpPortRanges];
        newUdpPortRanges[index][position] = newValue;
        setUdpPortRanges(newUdpPortRanges)
    }
    function isValidPort(str) {
        // Convert string to number
        let num = parseInt(str);
        // Check if the conversion resulted in a valid number
        if (!isNaN(num)) {
            // Check if the number is within the range 0 to 65535
            if (num >= 0 && num <= 65535) {
                return true;
            }
        }
        return false;
    }

    function isValidPortRange(range) {
        for (const port of range) {
            if (!isValidPort(port)) {
                return false;
            }
        }

        return range.length === 2 ? true : false;
    }


    function isValidPortRangesState() {
        if (replacePortRanges !== "No Change") {
            for (const range of tcpPortRanges) {
                if (!isValidPortRange(range)) {
                    return false
                }
            }
            for (const range of udpPortRanges) {
                if (!isValidPortRange(range)) {
                    return false
                }
            }
            return tcpPortRanges.length > 0 || udpPortRanges.length > 0
        }
        return true;
    }

    function addTcpPortRange() {
        setTcpPortRanges(prevState => [...prevState, []]);
    }

    function addUdpPortRange() {
        setUdpPortRanges(prevState => [...prevState, []]);
    }

    function removeTcpPortRange(index) {
        const newTcpPortRanges = [...tcpPortRanges];
        newTcpPortRanges.splice(index, 1);
        setTcpPortRanges(newTcpPortRanges);
    }

    function removeUdpPortRange(index) {
        const newUdpPortRanges = [...udpPortRanges];
        newUdpPortRanges.splice(index, 1);
        setUdpPortRanges(newUdpPortRanges);
    }

    function portRangesToText(ranges) {
        const text = ranges.map(pair => pair.join('-')).join('\n')
        return text;
    }

    function textToPortRanges(text) {
        const ranges = text.split('\n').map(pair => pair.split('-'));
        return ranges;
    }


    useEffect(() => {
        if (selectedTab === "updateAppSegment" && verified) {
            handleSubmit(new Event("LOL"))
        }
        setVerified(false);
    }, [verified])
    useEffect(() => {
        if (failed.length > 0) {
            setLoadingMessage(`Updating App Segments... (${updated.length + failed.length}/${selected.filter((element) => element.name != "Select All").length})`);
            const failedAppSegment = failed[failed.length - 1];
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tStatus: Failed \n\tName: ${failedAppSegment.name} \n\tReason: ${failedAppSegment.message}`);
            if (updated.length + failed.length == selected.filter((element) => element.name != "Select All").length) {
                terminateSession(accessToken);
                outputResponseUserStatus();
                setSelected([]);
                getAppSegments()

            }
        }

    }, [failed]);

    useEffect(() => {
        if (updated.length > 0) {
            setLoadingMessage(`Updating App Segments... (${failed.length + updated.length}/${selected.filter((element) => element.name != "Select All").length})`);
            const updatedAppSegment = updated[updated.length - 1];
            appendConsoleSeperatorSecondary();
            appendConsole(`\n\tStatus: Updated \n\tName: ${updatedAppSegment}`);
            if (failed.length + updated.length == selected.filter((element) => element.name != "Select All").length) {
                terminateSession(accessToken);
                outputResponseUserStatus();
                setSelected([]);
                getAppSegments()
            }
        }
    }, [updated]);

    useEffect(() => {
        setSelected([]);
    }, [tenant])

    useEffect(() => {
        setTcpPortsAsText(portRangesToText(tcpPortRanges))
        setUdpPortsAsText(portRangesToText(udpPortRanges))
        setIsValidPortRanges(isValidPortRangesState())
    }, [tcpPortRanges, udpPortRanges, replacePortRanges])




    useEffect(() => {
        scrollToBottom();
    }, [outputConsole])

    useEffect(() => {
        scrollToTop();
    }, [isLoading])

    useEffect(() => {
        console.log(appSegments)
    }, [appSegments])


    useEffect(() => {
        console.log(selected)
    }, [selected])




    useEffect(() => {
        if (appSegments[tenant].length == []) {
            getAppSegments();
        }
        const JWT = Cookies.get('CF_Authorization');
        const decodedJWT = jwtDecode(JWT)
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const date = `${day}-${month}-${year}`;
        setDescriptionTag(`${date}/${decodedJWT.email}`)
    }, [])



    async function terminateSession(access_token) {
        //Signout
        setLoadingMessage("Terminating Session...");
        await SignOut(access_token);
        setLoading(false);
    }
    return (
        <Container className=' pt-4 px-5 text-white pb-6'>
            <Row>
                <Col>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup controlId="company">
                            <Form.Label>
                                Select tenant
                            </Form.Label>
                            <Form.Select aria-label="Default select example" value={tenant} onChange={(e) => setTenant(e.target.value)} >
                                {
                                    Object.keys(groups).map((key, index) => (
                                        <option key={index} value={key}>{key}</option>
                                    ))

                                }
                            </Form.Select>
                        </FormGroup>

                        <FormGroup controlId="appSegments" className='mt-4'>
                            <Form.Label>
                                {appSegments[tenant].length === 0 ?
                                    <>
                                        <Spinner
                                            variant='light'
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                        />
                                        &nbsp;&nbsp;
                                    </> : <></>}
                                App Segments
                            </Form.Label>
                            <Multiselect
                                avoidHighlightFirstOption="true"
                                placeholder='Select'
                                showCheckbox="true"
                                showArrow="true"
                                selectedValues={selected}
                                customArrow={<FontAwesomeIcon icon="fa-solid fa-angle-down" style={{ color: "#c6cbce", }} size='sm' />}
                                options={appSegments[tenant].length > 0 ? [{ name: "Select All" }, ...appSegments[tenant]] : []}// Options to display in the dropdown
                                displayValue="name" // Property name to display in the dropdown options
                                onSelect={(selectedList, selectedItem) => evaluateSelect(selectedList, selectedItem)}
                                onRemove={(selectedList, selectedItem) => evaluateRemove(selectedList, selectedItem)}
                                ref={multiselectRef}
                                loading={appSegments[tenant].length < 1}
                                loadingMessage={"Loading App Segments"}
                                emptyRecordMsg="No App Segments Found"
                            />
                        </FormGroup>


                        {/* Options */}

                        <FormGroup className='mt-4' controlId="status">
                            <Form.Label>
                                Status
                            </Form.Label>
                            <Form.Select className={status === "No Change" ? "" : "border-warning"} value={status} onChange={(e) => setStatus(e.target.value)} >
                                <option value="No Change">No Change</option>
                                <option value={true}>Enabled</option>
                                <option value={false}>Disabled</option>
                            </Form.Select>
                        </FormGroup>


                        <FormGroup className='mt-4' controlId="doubleEncrypt">
                            <Form.Label>
                                Double Encryption
                            </Form.Label>
                            <Form.Select className={doubleEncrypt === "No Change" ? "" : "border-warning"} value={doubleEncrypt} onChange={(e) => setDoubleEncrypt(e.target.value)} >
                                <option value="No Change">No Change</option>
                                <option value={true}>Enabled</option>
                                <option value={false}>Disabled</option>
                            </Form.Select>
                        </FormGroup>

                        <FormGroup className='mt-4' controlId="icmpAccess">
                            <Form.Label>
                                ICMP Access
                            </Form.Label>
                            <Form.Select className={icmpAccessType === "No Change" ? "" : "border-warning"} value={icmpAccessType} onChange={(e) => setIcmpAccessType(e.target.value)} >
                                <option value="No Change">No Change</option>
                                <option value={"PING"}>Enabled</option>
                                <option value={"NONE"}>Disabled</option>
                            </Form.Select>
                        </FormGroup>

                        <FormGroup className='mt-4' controlId="bypassType">
                            <Form.Label>
                                Bypass Type
                            </Form.Label>
                            <Form.Select className={bypassType === "No Change" ? "" : "border-warning"} value={bypassType} onChange={(e) => setBypassType(e.target.value)} >
                                <option value="No Change">No Change</option>
                                <option value="NEVER">Use Client Forwarding Policy</option>
                                <option value="ALWAYS">Always</option>
                                <option value="ON_NET">On Corporate Network</option>
                            </Form.Select>
                        </FormGroup>

                        <FormGroup className='mt-4' controlId="bypassDuringReauthentication">
                            <Form.Label>
                                Bypass During Reauthentication
                            </Form.Label>
                            <Form.Select className={bypassDuringReauthentication === "No Change" ? "" : "border-warning"} value={bypassDuringReauthentication} onChange={(e) => setBypassDuringReauthentication(e.target.value)} >
                                <option value="No Change">No Change</option>
                                <option value={true}>Enabled</option>
                                <option value={false}>Disabled</option>
                            </Form.Select>
                        </FormGroup>

                        <FormGroup className='mt-4' controlId="healthReporting">
                            <Form.Label>
                                Health Reporting
                            </Form.Label>
                            <Form.Select className={healthReporting === "No Change" ? "" : "border-warning"} value={healthReporting} onChange={(e) => setHealthReporting(e.target.value)} >
                                <option value="No Change">No Change</option>
                                <option value="ON_ACCESS">On Access</option>
                                <option value="CONTINUOUS">Continuous</option>
                                <option value="NONE">None</option>
                            </Form.Select>
                        </FormGroup>

                        <FormGroup className='mt-4' controlId="isCnameEnabled">
                            <Form.Label>
                                Client Connecter Can Receive Cname
                            </Form.Label>
                            <Form.Select className={isCnameEnabled === "No Change" ? "" : "border-warning"} value={isCnameEnabled} onChange={(e) => setIsCnameEnabled(e.target.value)} >
                                <option value="No Change">No Change</option>
                                <option value={true}>Enabled</option>
                                <option value={false}>Disabled</option>
                            </Form.Select>
                        </FormGroup>

                        <FormGroup className='mt-4' controlId="selectConnectorCloseToApp">
                            <Form.Label>
                                App Connector Selection Method
                            </Form.Label>
                            <Form.Select className={selectConnectorCloseToApp === "No Change" ? "" : "border-warning"} value={selectConnectorCloseToApp} onChange={(e) => setSelectConnectorCloseToApp(e.target.value)} >
                                <option value="No Change">No Change</option>
                                <option value={true}>Closer to Application</option>
                                <option value={false}>Closer to User</option>
                            </Form.Select>
                        </FormGroup>



                        <FormGroup className='mt-4' controlId="selectConnectorCloseToApp">
                            <Form.Label>
                                Port Range Modification Method
                            </Form.Label>
                            <Form.Select className={selectConnectorCloseToApp === "No Change" ? "" : "border-warning"} value={replacePortRanges} onChange={(e) => setReplacePortRanges(e.target.value)} >
                                <option value="No Change">No Change</option>
                                <option value={true}>Replace Existing Port Ranges</option>
                                <option value={false}>Add to Existing Port Ranges</option>
                            </Form.Select>
                        </FormGroup>

                        {replacePortRanges != "No Change" ?
                            <>
                                <FormGroup controlId="tcpPortRanges" className='mt-4'>
                                    <Form.Label>
                                        TCP Port Ranges {replacePortRanges == "true" ? "(If no ports are specific TCP ports will not be replaced)" : ""} &nbsp;
                                        <Badge pill className='custom-badge' style={{ fontSize: 14 }} onClick={() => setTcpTextView(prev => !prev)}>
                                            {tcpTextView ? "Switch To Field View" : "Switch To Text View"}
                                        </Badge>
                                    </Form.Label>
                                    {
                                        tcpTextView ?
                                            <Form.Control required value={tcpPortsAsText} onChange={(event) => { setTcpPortRanges(textToPortRanges(event.target.value)) }} rows={5} as="textarea" placeholder={`443-443\n80-80`} />
                                            :
                                            tcpPortRanges.map((range, index) => (
                                                <Row className='align-items-center'>
                                                    <Col>
                                                        <Form.Control
                                                            type="number"
                                                            className='mt-1'
                                                            placeholder=""
                                                            value={range[0]}
                                                            onChange={(e) => handleTcpChange(e.target.value, index, 0)}
                                                        />
                                                    </Col>
                                                    _
                                                    <Col>
                                                        <Form.Control
                                                            type="number"
                                                            className='mt-1'
                                                            placeholder=""
                                                            value={range[1]}
                                                            onChange={(e) => handleTcpChange(e.target.value, index, 1)}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <FontAwesomeIcon className='custom-badge' icon={faTrash} style={{ color: "#dc3545", }} onClick={() => removeTcpPortRange(index)}
                                                        />
                                                    </Col>
                                                </Row>
                                            ))}
                                    <br></br>
                                    <Badge pill className='custom-badge' hidden={tcpTextView} style={{ fontSize: 14 }} onClick={addTcpPortRange}>
                                        Add
                                    </Badge>
                                </FormGroup>
                                <FormGroup controlId="udpPortRanges" className='mt-4'>
                                    <Form.Label>
                                        UDP Port Ranges {replacePortRanges ? "(If no ports are specific TCP ports will not be replaced)" : ""}&nbsp;
                                        <Badge pill className='custom-badge' style={{ fontSize: 14 }} onClick={() => setUdpTextView(prev => !prev)}>
                                            {udpTextView ? "Switch To Field View" : "Switch To Text View"}
                                        </Badge>
                                    </Form.Label>
                                    {
                                        udpTextView ?
                                            <Form.Control required value={udpPortsAsText} onChange={(event) => { setUdpPortRanges(textToPortRanges(event.target.value)) }} rows={5} as="textarea" placeholder={`443-443\n80-80`} />
                                            :
                                            udpPortRanges.map((range, index) => (
                                                <Row className='align-items-center'>
                                                    <Col>
                                                        <Form.Control
                                                            type="number"
                                                            className='mt-1'
                                                            placeholder=""
                                                            value={range[0]}
                                                            onChange={(e) => handleUdpChange(e.target.value, index, 0)}
                                                        />
                                                    </Col>
                                                    _
                                                    <Col>
                                                        <Form.Control
                                                            type="number"
                                                            className='mt-1'
                                                            placeholder=""
                                                            value={range[1]}
                                                            onChange={(e) => handleUdpChange(e.target.value, index, 1)}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <FontAwesomeIcon className='custom-badge' icon={faTrash} style={{ color: "#dc3545", }} onClick={() => removeUdpPortRange(index)}
                                                        />
                                                    </Col>
                                                </Row>
                                            ))}
                                    <br></br>
                                    <Badge pill className='custom-badge' style={{ fontSize: 14 }} hidden={udpTextView} onClick={addUdpPortRange}>
                                        Add
                                    </Badge>
                                </FormGroup>
                            </> : <></>

                        }


                        <FormGroup controlId="description" className='mt-4'>
                            <Form.Label>
                                Description (Will be added to the description for each app segment)
                            </Form.Label>

                            <InputGroup className="">
                                <InputGroup.Text id="basic-addon2">{descriptionTag}</InputGroup.Text>
                                <Form.Control type='text' required value={description} onChange={(e) => setDescription(e.target.value)} placeholder='Some Description...' />
                            </InputGroup>
                        </FormGroup>

                        <Button className='mt-4 text-light' type='submit' disabled={isLoading || selected.length < 1 || !isValidPortRanges} variant="primary" >
                            {isLoading ?
                                <span>
                                    <Spinner
                                        variant='light'
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    {"  " + loadingMessage}
                                </span> : `Update App Segment(s)`}
                        </Button>
                    </Form>
                </Col>
            </Row>
            <Row className='mt-5 '>
                <Col>
                    <ProgressBar className='mb-2' now={isLoading ? (updated.length + failed.length) / selected.filter((app_segment) => app_segment.name != "Select All").length * 100 : 0} />
                </Col>
            </Row>
            <Row className='mt-0 text-center'>
                <Col className=''>
                    <textarea value={outputConsole} className='w-100 bg-dark-subtle text-rheintec-blue output-terminal' rows="20" readOnly ref={textareaRef}>
                    </textarea>
                </Col>

            </Row>

        </Container >

    );

}

export default UpdateAppSegmentTab;